<app-header></app-header>
<div class="container-fluid section">
    <div class="row justify-content-center">
        <div class="col-11 col-sm-10 sub-section my-3 p-4">
            <span class="title">Edit profile</span>
            <form [formGroup]="profileForm">
                <div class="row justify-content-center mt-5">
                    <div class="col-sm-9 col-md-8 col-lg-7 col-xl-5">
                        <div class="d-flex flex-row">
                            <div class="image-container-before mr-4" *ngIf="!pictureUrl">
                                <img src="../../../assets/Images/nurse.svg" alt="profile pic">
                            </div>
                            <img *ngIf="pictureUrl" [src]="pictureUrl" class="image-container-after mr-4" />
                            <div class="d-flex flex-column">
                                <button class="btn btn-theme-inverse mt-3 d-flex flex-row" data-toggle="modal"
                                    data-target="#image-upload" (click)="openModal('upload')">
                                    <img src="../../../assets/Images/upload-icon.svg" class="icon mr-2">
                                    <span class="icon-text"> Upload profile picture</span>
                                </button>
                                <button class="btn btn-theme-inverse mt-3 d-flex flex-row" data-toggle="modal"
                                    data-target="#image-upload" (click)="openModal('camera')">
                                    <img src="../../../assets/Images/camera-icon.svg" class="icon mr-2">
                                    <span class="icon-text"> Capture using camera</span>
                                </button>
                                <button class="btn btn-theme-inverse mt-3 d-flex flex-row" [disabled]="!pictureUrl"
                                    (click)="removeProfile()">
                                    <img src="../../../assets/Images/delete-icon.svg" class="icon mr-2">
                                    <span class="icon-text"> Delete Photo</span>
                                </button>
                            </div>
                        </div>
                        <div class="btn-group btn-group-toggle w-100 mt-4">
                            <button class="btn btn-toggler" (click)="screen=1;" [ngClass]="{active: screen==1}">
                                <label>Personal details</label></button>
                            <button class="btn btn-toggler" (click)="screen=2;" [ngClass]="{active: screen==2}">
                                <label>About</label></button>
                            <button class="btn btn-toggler" (click)="screen=3;" [ngClass]="{active: screen==3}">
                                <label>Other details</label></button>
                        </div>
                        <div class="d-flex flex-column" *ngIf="screen==1">
                            <span class="input-label mt-3 mb-1">Name</span>
                            <input class="form-control form-control-sm header-search" formControlName="name"
                                placeholder="Name">
                            <span class="input-label mt-3 mb-1">Email</span>
                            <input class="form-control form-control-sm header-search" formControlName="userEmail"
                                type="email" placeholder="Email">
                            <div class="row">
                                <div class="col-md-6 pr-md-0">
                                    <div class="d-flex flex-column">
                                        <span class="input-label mt-3 mb-1">Country code</span>
                                        <mat-form-field class="w-100">
                                            <mat-select formControlName="countryCode" name="country code mum"
                                                id="country-code-mum">
                                                <mat-option *ngFor="let country of countries"
                                                    [value]="country.dial_code">
                                                    <img class="dropdown-profile-img"
                                                        [src]="country.flag">{{country.name}}
                                                    <span class="text-muted">({{country.dial_code}})</span>
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="d-flex flex-column">
                                        <span class="input-label mt-3 mb-1">Phone 1 (Home)</span>
                                        <input class="form-control form-control-sm header-search"
                                            formControlName="userPhonenumber" type="tel" placeholder="Phone">
                                    </div>
                                </div>
                            </div>
                            <span class="input-label mt-3 mb-1">Phone 1 (Office)</span>
                            <input class="form-control form-control-sm header-search" formControlName="alternatePhone"
                                type="tel" placeholder="Phone">
                            <span class="input-label mt-3 mb-1">Address</span>
                            <mat-form-field class="w-100" appearance="fill">
                                <input type="text" placeholder="Search Area" matInput [formControl]="myControl"
                                    [matAutocomplete]="auto">
                                <mat-autocomplete #auto="matAutocomplete"
                                    (optionSelected)='selectArea($event.option.value)'>
                                    <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                                        {{option}}
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                            <span class="input-label mt-3">Ethnicity</span>
                            <mat-form-field class="w-100 mb-1">
                                <mat-select formControlName="ethnicity" name="ethnicity" id="Ethnicity">
                                    <mat-option *ngFor="let ethnicity of ethnicities" [value]="ethnicity">{{ethnicity}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <span class="input-label mt-3 mb-1">Languages</span>
                            <mat-form-field class="w-100">
                                <mat-select #selectLanguageEdit [formControl]="languageCtrl" multiple id="Language"
                                    name="language">
                                    <div>
                                        <mat-option [value]="0" (click)="toggleAllSelection('Language')">All
                                        </mat-option>
                                        <mat-option *ngFor="let language of languages" [value]="language">{{language}}
                                        </mat-option>
                                    </div>
                                    <footer class="mr-2 mb-2 float-right">
                                        <button mat-flat-button color="primary" class="done-btn"
                                            (click)="closeDropdown()">Done</button>
                                    </footer>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="d-flex flex-column" *ngIf="screen==2">
                            <span class="input-label mt-3 mb-2">Write something about you</span>
                            <textarea class="form-control form-control-sm header-search" rows="10"
                                formControlName="intro" placeholder="Write something about you"></textarea>
                        </div>
                        <div class="d-flex flex-column" *ngIf="screen==3">
                            <span class="input-label mt-3 mb-1 text-muted">Apc number</span>
                            <input class="form-control form-control-sm header-search" formControlName="practiceId"
                                placeholder="NZMF5584512107">
                            <span class="input-label mt-3 mb-1">Specialized in</span>
                            <mat-form-field class="w-100">
                                <mat-select #selectSpecializedEdit [formControl]="specialized" multiple
                                    name="specializedin" id="Specialized in">
                                    <mat-select-trigger>
                                        <span *ngFor="let t of specialized.value; let i = index">{{t}}<span
                                                *ngIf="i != specialized.value.length - 1">,
                                            </span></span>
                                    </mat-select-trigger>
                                    <mat-option [value]="0" (click)="toggleAllSelection('Specialized')">All</mat-option>
                                    <mat-option *ngFor="let speciality of specialities" [value]="speciality">
                                        {{speciality}}</mat-option>
                                    <footer class="mr-2 mb-2 float-right">
                                        <button mat-flat-button color="primary" class="done-btn"
                                            (click)="closeDropdown()">Done</button>
                                    </footer>
                                </mat-select>
                            </mat-form-field>
                            <span class="input-label mt-3 mb-2">Service areas</span>
                            <div class="d-flex flex-row">
                                <mat-form-field class="w-100 mb-2 mr-2">
                                    <mat-select id="area" [formControl]="selectedArea" name="area">
                                        <mat-option *ngFor="let area of areas" [value]="area">{{area.name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field class="w-100">
                                    <mat-select #selectAreasEdit id="subarea" multiple name="subarea"
                                        [formControl]="serviceCtrl" [disabled]="selectedArea.value==undefined">
                                        <div>
                                            <mat-option [value]="0" (click)="toggleAllSelection('Area')">All
                                            </mat-option>
                                            <mat-option *ngFor="let subArea of subAreas" [value]="subArea.name"
                                                [ngClass]="{'d-none': selectedArea.value && subArea.parentId != selectedArea.value.id}">
                                                {{subArea.name}}
                                            </mat-option>
                                        </div>
                                        <footer class="mr-2 mb-2 float-right">
                                            <button mat-flat-button color="primary" class="done-btn"
                                                (click)="closeDropdown()">Done</button>
                                        </footer>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <span class="input-label mt-2">Experience</span>
                            <mat-form-field class="w-100 mb-1">
                                <mat-select name="experience" id="Experience" formControlName="experienceInYears">
                                    <mat-option [value]="experience" *ngFor="let experience of experiences">
                                        {{experience}} years</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <span class="input-label mt-3 mb-1">Password</span>
                            <div class="input-icons">
                                <i class="fas eye-icon" [ngClass]="{'fa-eye': eye, 'fa-eye-slash': !eye}"
                                    (click)="toggle('midwife')"></i>
                                <input #pass class="form-control form-control-sm header-search"
                                    formControlName="newPassword" placeholder="Password" type="password">
                            </div>
                        </div>
                        <div class="horizontal-line my-4"></div>
                        <div class="d-flex flex-row justify-content-end">
                            <button class="btn btn-cancel mr-2" [routerLink]="['/dashboard']">Cancel</button>
                            <button class="btn btn-theme" (click)="updateProfile()" [disabled]="!profileForm.valid || !specialized.value.length || !languageCtrl.value.length
                                || !serviceCtrl.value.length">
                                <div class="d-flex flex-row justify-content-center">
                                    <div class="spinner-border loader" role="status" *ngIf="loading">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span class="align-self-center" *ngIf="!loading">Save</span>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Image Upload Modal Starts-->
<app-image-upload (profilePic)="setProfile($event)" [aspectRatio]="1 / 1" [mode]="'profile pic'"></app-image-upload>
<!-- Image Upload Modal Ends-->
